import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", {
  d: "M15.9577 0H1.99471C0.887645 0 0 0.89 0 2V6H1.99471V2H15.9577V16H1.99471V12H0V16C0 16.5304 0.210156 17.0391 0.584237 17.4142C0.958317 17.7893 1.46568 18 1.99471 18H15.9577C16.4867 18 16.9941 17.7893 17.3681 17.4142C17.7422 17.0391 17.9524 16.5304 17.9524 16V2C17.9524 1.46957 17.7422 0.960859 17.3681 0.585786C16.9941 0.210714 16.4867 0 15.9577 0ZM7.06127 12.58L8.47751 14L13.4643 9L8.47751 4L7.06127 5.41L9.64442 8H0V10H9.64442L7.06127 12.58Z",
  fill: "black"
}, null, -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconBase = _resolveComponent("IconBase");

  return _openBlock(), _createBlock(_component_IconBase, {
    "view-box": "0 0 18 18",
    "icon-name": "login",
    width: 18,
    height: 18
  }, {
    default: _withCtx(() => [_hoisted_1]),
    _: 1
  });
}